/* Thread N Cloud — theme scripts (no dependencies) */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Announcement bar ---------- */
  function initAnnouncements() {
    $$('[data-announcement]').forEach((bar) => {
      const slides = $$('.announcement__slide', bar);
      if (slides.length < 2) return;
      let i = 0;
      const show = (n) => {
        slides[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
      };
      let timer = setInterval(() => show(i + 1), 5000);
      const reset = () => { clearInterval(timer); timer = setInterval(() => show(i + 1), 5000); };
      $('[data-prev]', bar)?.addEventListener('click', () => { show(i - 1); reset(); });
      $('[data-next]', bar)?.addEventListener('click', () => { show(i + 1); reset(); });
    });
  }

  /* ---------- Header: dropdowns, search, drawer ---------- */
  function initHeader() {
    $$('[data-dropdown-toggle]').forEach((btn) => {
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const open = btn.getAttribute('aria-expanded') === 'true';
        $$('[data-dropdown-toggle][aria-expanded="true"]').forEach((b) => {
          b.setAttribute('aria-expanded', 'false');
          document.getElementById(b.getAttribute('aria-controls'))?.classList.remove('is-open');
        });
        if (!open) {
          btn.setAttribute('aria-expanded', 'true');
          panel?.classList.add('is-open');
        }
      });
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.header__menu > li')) {
        $$('[data-dropdown-toggle][aria-expanded="true"]').forEach((b) => {
          b.setAttribute('aria-expanded', 'false');
          document.getElementById(b.getAttribute('aria-controls'))?.classList.remove('is-open');
        });
      }
    });

    const searchBtn = $('[data-search-toggle]');
    const searchPanel = $('[data-search-panel]');
    searchBtn?.addEventListener('click', () => {
      const open = searchPanel.classList.toggle('is-open');
      searchBtn.setAttribute('aria-expanded', open);
      if (open) $('input', searchPanel)?.focus();
    });

    const drawer = $('[data-drawer]');
    const openDrawer = () => { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; $('[data-drawer-close]', drawer)?.focus(); };
    const closeDrawer = () => { drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
    $$('[data-drawer-open]').forEach((b) => b.addEventListener('click', openDrawer));
    $$('[data-drawer-close]').forEach((b) => b.addEventListener('click', closeDrawer));

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (drawer?.classList.contains('is-open')) closeDrawer();
      searchPanel?.classList.remove('is-open');
      $$('.hotspot__pop.is-open').forEach((p) => p.classList.remove('is-open'));
    });
  }

  /* ---------- Carousels ---------- */
  function initCarousels() {
    $$('[data-carousel]').forEach((root) => {
      const track = $('.carousel__track', root);
      const prev = $('[data-carousel-prev]', root);
      const next = $('[data-carousel-next]', root);
      const dotsWrap = $('.carousel__dots', root);
      if (!track) return;

      const pageCount = () => Math.max(1, Math.ceil((track.scrollWidth - 40) / track.clientWidth));
      const buildDots = () => {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        const n = pageCount();
        for (let p = 0; p < n; p++) {
          const d = document.createElement('button');
          d.className = 'carousel__dot';
          d.type = 'button';
          d.setAttribute('aria-label', 'Go to slide ' + (p + 1));
          d.addEventListener('click', () => track.scrollTo({ left: p * track.clientWidth }));
          dotsWrap.appendChild(d);
        }
        const controls = $('.carousel__controls', root);
        if (controls) controls.hidden = n < 2;
        update();
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        if (dotsWrap) {
          const active = Math.round(track.scrollLeft / track.clientWidth);
          $$('.carousel__dot', dotsWrap).forEach((d, idx) => d.classList.toggle('is-active', idx === active));
        }
      };
      prev?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth }));
      next?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth }));
      track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', buildDots);
      buildDots();
    });
  }

  /* ---------- Feature banner (thumbnail gallery) ---------- */
  function initFeatureBanners() {
    $$('[data-feature-banner]').forEach((root) => {
      const thumbs = $$('.feature-banner__thumb', root);
      const slides = $$('.feature-banner__slide', root);
      thumbs.forEach((t, idx) => t.addEventListener('click', () => {
        thumbs.forEach((x) => x.classList.toggle('is-active', x === t));
        slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      }));
    });
  }

  /* ---------- Hotspots ---------- */
  function initHotspots() {
    $$('.hotspot').forEach((spot) => {
      const pop = document.getElementById(spot.getAttribute('aria-controls'));
      spot.addEventListener('click', (e) => {
        e.stopPropagation();
        const willOpen = !pop.classList.contains('is-open');
        $$('.hotspot__pop.is-open').forEach((p) => p.classList.remove('is-open'));
        $$('.hotspot[aria-expanded="true"]').forEach((s) => s.setAttribute('aria-expanded', 'false'));
        if (willOpen) { pop.classList.add('is-open'); spot.setAttribute('aria-expanded', 'true'); }
      });
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.hotspot__pop')) $$('.hotspot__pop.is-open').forEach((p) => p.classList.remove('is-open'));
    });
  }

  /* ---------- Compare slider ---------- */
  function initCompare() {
    $$('[data-compare]').forEach((root) => {
      const range = $('.compare__range', root);
      const set = () => root.style.setProperty('--pos', range.value + '%');
      range.addEventListener('input', set);
      set();
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty]');
      if (!btn) return;
      const input = btn.parentElement.querySelector('input');
      const min = parseInt(input.min || '0', 10);
      const v = parseInt(input.value || '0', 10) + (btn.dataset.qty === 'plus' ? 1 : -1);
      input.value = Math.max(min, v);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Product image lightbox ---------- */
  function initLightbox(root) {
    const box = $('[data-lightbox]', root);
    const slides = $$('.gallery__slide[data-zoom-src]', root);
    if (!box || !slides.length) return;
    const track = $('[data-lightbox-track]', box);
    const count = $('[data-lightbox-count]', box);
    const prev = $('[data-lightbox-prev]', box);
    const next = $('[data-lightbox-next]', box);
    let index = 0;
    let lastFocus = null;
    let built = false;

    const build = () => {
      if (built) return;
      track.innerHTML = slides.map((s) =>
        `<figure class="lightbox__slide"><img src="${s.dataset.zoomSrc}" alt="${(s.dataset.zoomAlt || '').replace(/"/g, '&quot;')}" decoding="async"></figure>`
      ).join('');
      built = true;
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index) { index = i; update(); }
      }, { passive: true });
      $$('.lightbox__slide img', track).forEach((img) => img.addEventListener('click', (e) => {
        e.stopPropagation();
        img.closest('.lightbox__slide').classList.toggle('is-zoomed');
      }));
      $$('.lightbox__slide', track).forEach((f) => f.addEventListener('click', (e) => { if (e.target === f) close(); }));
    };

    const update = () => {
      const single = slides.length < 2;
      prev.hidden = single || index === 0;
      next.hidden = single || index === slides.length - 1;
      count.textContent = single ? '' : `${index + 1} / ${slides.length}`;
    };

    const go = (i, smooth = true) => {
      index = Math.max(0, Math.min(slides.length - 1, i));
      $$('.lightbox__slide.is-zoomed', track).forEach((f) => f.classList.remove('is-zoomed'));
      track.scrollTo({ left: index * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      update();
    };

    const onKey = (e) => {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(index + 1);
      else if (e.key === 'ArrowLeft') go(index - 1);
      else if (e.key === 'Tab') {
        const f = $$('button:not([hidden])', box);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    };

    const open = (i) => {
      build();
      lastFocus = document.activeElement;
      box.hidden = false;
      document.documentElement.classList.add('lightbox-open');
      requestAnimationFrame(() => { go(i, false); box.classList.add('is-open'); });
      document.addEventListener('keydown', onKey);
      $('[data-lightbox-close]', box).focus();
    };

    const close = () => {
      box.classList.remove('is-open');
      box.hidden = true;
      document.documentElement.classList.remove('lightbox-open');
      document.removeEventListener('keydown', onKey);
      lastFocus?.focus();
    };

    slides.forEach((s, i) => {
      $('.gallery__zoom', s)?.addEventListener('click', () => open(i));
    });
    prev.addEventListener('click', () => go(index - 1));
    next.addEventListener('click', () => go(index + 1));
    $('[data-lightbox-close]', box).addEventListener('click', close);
    window.addEventListener('resize', () => { if (!box.hidden) go(index, false); });
  }

  /* ---------- Product: variants + gallery ---------- */
  function initProduct() {
    $$('[data-product]').forEach((root) => {
      const dataEl = $('[data-product-json]', root);
      if (!dataEl) return;
      const product = JSON.parse(dataEl.textContent);
      const form = $('[data-product-form]', root);
      const idInput = $('input[name="id"]', form);
      const priceEl = $('[data-price]', root);
      const stockEl = $('[data-stock]', root);
      const addBtn = $('[data-add]', root);
      const forceSoldOut = root.hasAttribute('data-force-soldout');
      const money = (cents) => {
        const fmt = root.dataset.moneyFormat || '{{amount}}';
        const amount = (cents / 100).toFixed(2);
        const noDec = Math.round(cents / 100).toLocaleString('en-US');
        const withDec = Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2 });
        return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec).replace(/\{\{\s*amount\s*\}\}/, withDec).replace(/\{\{\s*\w+\s*\}\}/, withDec);
      };

      const selected = () => $$('fieldset.option', root).map((fs) => {
        const c = $('input:checked', fs);
        return c ? c.value : null;
      });

      const updateLegend = () => {
        $$('fieldset.option', root).forEach((fs) => {
          const c = $('input:checked', fs);
          const s = $('legend span', fs);
          if (c && s) s.textContent = c.value;
        });
      };

      const markAvailability = (opts) => {
        $$('fieldset.option', root).forEach((fs, idx) => {
          $$('input', fs).forEach((inp) => {
            const test = opts.slice(); test[idx] = inp.value;
            const match = product.variants.find((v) => v.options.every((o, i) => o === test[i]));
            inp.nextElementSibling.classList.toggle('is-unavailable', !match || !match.available || forceSoldOut);
          });
        });
      };

      const goToMedia = (mediaId) => {
        const slide = $(`[data-media-id="${mediaId}"]`, root);
        if (!slide) return;
        const main = $('.gallery__main', root);
        main.scrollTo({ left: slide.offsetLeft - main.offsetLeft, behavior: 'smooth' });
        $$('.gallery__thumb', root).forEach((t) => t.classList.toggle('is-active', t.dataset.target === String(mediaId)));
      };

      const onChange = () => {
        const opts = selected();
        updateLegend();
        markAvailability(opts);
        const v = product.variants.find((x) => x.options.every((o, i) => o === opts[i]));
        if (!v) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
          return;
        }
        idInput.value = v.id;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());

        if (priceEl) {
          let html = '';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            const save = Math.round((1 - v.price / v.compare_at_price) * 100);
            html = `<span class="price__sale">${money(v.price)}</span><s class="price__compare">${money(v.compare_at_price)}</s><span class="price__save">Save ${save}%</span>`;
          } else {
            html = `<span>${money(v.price)}</span>`;
          }
          priceEl.innerHTML = html;
        }
        const avail = v.available && !forceSoldOut;
        if (stockEl) {
          stockEl.className = 'stock';
          if (!avail) { stockEl.classList.add('stock--out'); stockEl.textContent = 'Out of stock'; }
          else { stockEl.textContent = 'In stock'; }
        }
        addBtn.disabled = !avail;
        addBtn.textContent = avail ? addBtn.dataset.addLabel : 'Out of stock';
        if (v.featured_media) goToMedia(v.featured_media.id);
      };

      $$('fieldset.option input', root).forEach((inp) => inp.addEventListener('change', onChange));
      if ($$('fieldset.option', root).length) markAvailability(selected());

      /* gallery thumbs */
      $$('.gallery__thumb', root).forEach((t) => t.addEventListener('click', () => goToMedia(t.dataset.target)));
      const main = $('.gallery__main', root);
      main?.addEventListener('scroll', () => {
        const idx = Math.round(main.scrollLeft / main.clientWidth);
        $$('.gallery__thumb', root).forEach((t, i) => t.classList.toggle('is-active', i === idx));
      }, { passive: true });

      /* full-screen image viewer */
      initLightbox(root);

      /* add to cart with graceful fallback */
      form?.addEventListener('submit', async (e) => {
        if (!window.fetch) return;
        e.preventDefault();
        const errorEl = $('.product-form__error', root);
        if (errorEl) errorEl.hidden = true;
        addBtn.disabled = true;
        const original = addBtn.textContent;
        addBtn.textContent = 'Adding…';
        try {
          const res = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          const json = await res.json();
          if (!res.ok) throw new Error(json.description || 'Could not add to cart');
          const cart = await (await fetch('/cart.js')).json();
          $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
          addBtn.textContent = 'Added ✓';
          setTimeout(() => { addBtn.textContent = original; addBtn.disabled = false; }, 1600);
          const goto = root.dataset.afterAdd;
          if (goto === 'cart') window.location.href = '/cart';
        } catch (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          addBtn.textContent = original;
          addBtn.disabled = false;
        }
      });
    });
  }

  /* ---------- Collection filters ---------- */
  function initFacets() {
    $$('[data-facets-form]').forEach((form) => {
      form.addEventListener('change', (e) => {
        if (e.target.matches('input[type="number"]')) return;
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
    $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }));
    $$('[data-facets-toggle]').forEach((btn) => btn.addEventListener('click', () => {
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      const open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
    }));
  }

  /* ---------- Cart page ---------- */
  function initCart() {
    const form = $('[data-cart-form]');
    if (!form) return;
    let t;
    form.addEventListener('change', (e) => {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(() => form.submit(), 500);
    });
  }

  /* ---------- Hero video ---------- */
  function initHeroVideo() {
    $$('[data-hero-video]').forEach((media) => {
      const video = $('video', media);
      const btn = media.parentElement.querySelector('[data-hero-pause]');
      if (!video) return;
      video.muted = true;
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const setState = (paused) => { if (btn) { btn.setAttribute('aria-pressed', paused); btn.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video'); } };
      if (reduce) { video.pause(); setState(true); }
      else { const p = video.play(); if (p && p.catch) p.catch(() => setState(true)); }
      btn?.addEventListener('click', () => {
        if (video.paused) { video.play(); setState(false); } else { video.pause(); setState(true); }
      });
    });
  }

  /* ---------- Misc ---------- */
  function initMisc() {
    $$('[data-to-top]').forEach((b) => b.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' })));
  }

  /* ---------- Reviews: "Write a review" toggle ---------- */
  function initReviews() {
    $$('[data-review-toggle]').forEach((btn) => {
      const form = document.getElementById(btn.getAttribute('aria-controls'));
      if (!form) { btn.hidden = true; return; }
      if (!form.hidden) btn.setAttribute('aria-expanded', 'true');
      btn.addEventListener('click', () => {
        const open = form.hidden;
        form.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        if (open) {
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const first = form.querySelector('input[type="text"]');
          if (first) setTimeout(() => first.focus({ preventScroll: true }), 300);
        }
      });
    });
    // After a review is sent, Shopify reloads the page: jump back to the thank-you note.
    if (document.querySelector('.rv__thanks') && !location.hash) {
      document.getElementById('reviews')?.scrollIntoView();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAnnouncements();
    initHeader();
    initCarousels();
    initFeatureBanners();
    initHotspots();
    initCompare();
    initQty();
    initProduct();
    initFacets();
    initCart();
    initHeroVideo();
    initMisc();
    initReviews();
  });
})();
